const en = {
  common: {
    bookMeeting: "Book a meeting",
    requestDemo: "Request a Demo",
    languageSelectorLabel: "Choose language",
    languageNames: {
      en: "English",
      bg: "Bulgarian",
    },
    logoAlt: "Warenex logo",
    navigationLogoAlt: "Warenex navigation logo",
    serviceIconAlt: "Service",
    carouselItemAlt: "Selected company strength",
    previousSlide: "Previous company strength",
    nextSlide: "Next company strength",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    loadingImage: "Loading image",
  },
  navigation: {
    home: "Home",
    services: "Services",
    technologies: "Technologies",
    aboutUs: "About us",
    products: "Products",
    wecpDescription: "Warenex e-commerce platform",
    contactUs: "Contact us",
  },
  home: {
    hero: {
      title: "SHAPING TOMORROW'S WORLD",
      subtitle: "YOUR SUCCESS IS OUR MISSION",
      values: [
        "PROFESSIONALISM AND DEDICATION",
        "HIGHLY SKILLED TEAM",
        "FRIENDLY ATTITUDE",
      ],
    },
    services: {
      title: "WHAT TO EXPECT",
      paragraphs: [
        "Smooth process from start to finish, with careful attention to every detail, clear communication, and a strong focus on making sure you're happy.",
        "Working with us means more than just getting a product - it's like having a trusted partner by your side, ensuring your ideas come to life just the way you want.",
      ],
      items: [
        {
          title: "CONSULTING",
          description:
            "We analyze requirements, establish goals, and outline the project workflow to ensure success.",
        },
        {
          title: "DESIGN",
          description:
            "Our designers make easy-to-use and good-looking interfaces that work well on many devices.",
        },
        {
          title: "DEVELOPMENT",
          description:
            "Using cutting-edge technologies, we deliver high-performance software solutions for your needs.",
        },
        {
          title: "TESTING",
          description:
            "Our testing phase catches potential issues and ensures that the software meets expectations.",
        },
        {
          title: "SUPPORT",
          description:
            "We keep your software working well, update it when needed, and fix any problems that come up.",
        },
      ],
    },
    testimonials: {
      title: "SOME OF THE REASONS WE ARE DOING THIS",
      items: [
        "Working with Warenex has been an absolute pleasure for us. The employee management system they built for us exceeded our expectations in every way. We couldn't be happier with the results.",
        "Choosing Warenex to redesign our website has proven to be an excellent decision. The new design is not only visually stunning but also incredibly responsive across all devices. We received countless compliments from our customers.",
      ],
    },
    achievements: {
      title: "Smart Solutions, Real Results",
      items: [
        {
          title: "Smart Foodie Platform",
          description:
            "Smart Foodie is a comprehensive and easy-to-use platform featuring both web and mobile applications designed to support restaurant businesses. With Smart Foodie, clients can conveniently make reservations and place orders directly from their smartphones, making dining out simpler and more enjoyable.",
        },
        {
          title: "Global Car Auction System",
          description:
            "With the Global Car Auction System, users can join a worldwide car auction platform where sellers can easily list their vehicles. We've also created a logistics feature that helps our partners manage car deliveries smoothly, ensuring a seamless process.",
        },
        {
          title: "Modern House Website",
          description:
            "We have created a user-friendly website tailored to our partner's needs. From a personalized design to easy navigation, our focus was on delivering a seamless experience for customers browsing houses and metal structures on the website.",
        },
      ],
    },
    strengths: {
      title: "OUR STRENGTHS",
      items: [
        {
          heading: "KNOWLEDGE",
          text: "We continuously improve ourselves by staying up-to-date with the latest technologies and trends in the IT industry.",
        },
        {
          heading: "RESPONSIBILITY",
          text: "We are fully committed to the success of your projects, prioritizing accountability and transparency.",
        },
        {
          heading: "TEAMWORK",
          text: "Teamwork is the core of our company. We share new ideas, skills and experience to grow together.",
        },
        {
          heading: "PROFESSIONALISM",
          text: "We aim to maintain the highest standards of excellence, ethics, and communication in all our work.",
        },
      ],
    },
    contact: {
      title: "SHARE YOUR IDEA WITH US",
      directContactTitle: "OR GET IN TOUCH WITH US DIRECTLY",
      phoneHeading: "Make a call",
      phoneText:
        "Feel free to give us a call for a direct conversation with our team.",
      emailHeading: "Send us an E-mail",
      emailText:
        "Reach out to us by email for a detailed response to your inquiries.",
    },
  },
  about: {
    titleBefore: "Here are some things",
    titleHighlight: "about us",
    introBefore: "We are a software company focused on providing ",
    introHighlight: "innovative",
    introAfter:
      " technology solutions to our clients. We specialize in custom software development services.",
    companyPrefix: "At ",
    companySuffix:
      ", we understand that every client has unique needs, which is why we work closely with each client to understand their business requirements and create customized solutions to help them achieve their goals.",
    imageAlt: "Warenex team introduction",
    values: [
      "We strive to build long-term relationships with our clients. Our mission is to provide exceptional service that exceeds our clients' expectations and helps them succeed in their business.",
      "We believe that our success is a direct result of our clients' success, which is why we go above and beyond to deliver quality solutions that meet their specific needs.",
      "Our team uses a collaborative approach to software development, which involves continuous communication and feedback to ensure that we are meeting our clients' expectations.",
      "If you're interested in learning more about our services or how we can help your business, please don't hesitate to contact us. We look forward to the opportunity to work with you.",
    ],
  },
  servicesPage: {
    titleBefore: "Bring your vision to life with our ",
    titleHighlight: "services",
    intro:
      "At Warenex, we provide effective software solutions designed to boost your business growth. We excel in crafting top-notch websites, mobile applications, and visually appealing designs, thoroughly tested to guarantee optimal performance. Let us take care of the technical side, so you can focus on your business success.",
    imageAlt: "Warenex software services",
    items: [
      {
        title: "Web development",
        description:
          "Our web development team crafts responsive, high-performance websites using cutting-edge technologies. We help you establish a robust online presence to engage and attract your target audience.",
      },
      {
        title: "Mobile development",
        description:
          "We specialize in creating intuitive, user-friendly mobile applications for iOS and Android. Our mobile development services ensure your business stays connected and accessible to your customers on-the-go.",
      },
      {
        title: "UX/UI design",
        description:
          "Our designers focus on creating visually appealing, user-centered designs that enhance usability and user satisfaction. We bridge the gap between functionality and aesthetics, ensuring your digital products provide an unforgettable experience.",
      },
      {
        title: "QA testing",
        description:
          "Our testing process ensures the reliability, security, and performance of your software products. We identify and resolve potential issues, delivering flawless solutions that stand the test of time.",
      },
    ],
  },
  technologiesPage: {
    titleBefore: "We believe in future of",
    titleHighlight: "technology",
    intro:
      "We stay up-to-date with the latest and most effective technologies in the industry. Our commitment to utilizing the best tools enables us to deliver outstanding software solutions for our clients. Below is a comprehensive list of the technologies we utilize to bring your ideas to life, ensuring quality, efficiency, and innovation in every project.",
    imageAlt: "Software technologies used by Warenex",
    exploreButton: "WHAT WE USE",
    categories: {
      frontEnd: "Front End",
      backEnd: "Back End",
      devOps: "DevOps",
      mobile: "Mobile",
      other: "Other",
    },
  },
  wecp: {
    hero: {
      title: "A Smarter E-commerce Platform Built for Growth",
      description:
        "WECP helps businesses sell online, manage daily operations, and give customers a smooth shopping experience across devices.",
      highlightsLabel: "Platform highlights",
      highlights: ["Scalable", "Secure", "Easy to use"],
      imageAlt:
        "Warenex e-commerce platform dashboard and mobile storefront",
    },
    advantages: {
      eyebrow: "Built to Deliver Results",
      title: "Why Teams Choose WECP",
      items: [
        {
          title: "User-Friendly Experience",
          description:
            "Beautiful, responsive storefronts that provide seamless shopping experiences across all devices.",
        },
        {
          title: "High Performance",
          description:
            "A responsive shopping experience designed to keep browsing clear and interactions smooth.",
        },
        {
          title: "Secure & Reliable",
          description:
            "Protected customer accounts and admin access, with dependable day-to-day operation.",
        },
        {
          title: "Flexible & Customizable",
          description:
            "Shape the catalog, storefront theme, homepage, and business details around your brand.",
        },
        {
          title: "Clear Sales Insights",
          description:
            "See sales, orders, average order value, units sold, and customer trends in one dashboard.",
        },
        {
          title: "Localization Ready",
          description:
            "Manage store languages, translated catalog content, and currencies from the admin workspace.",
        },
      ],
    },
    connectedCommerce: {
      eyebrow: "One Platform, Two Experiences",
      title: "Your Storefront and Back Office, Working Together",
      description:
        "Customers get a focused buying experience. Your team gets one place to manage what you sell, how the store looks, and what happens after checkout.",
      points: [
        "Customer-ready storefront",
        "Clear admin workspace",
        "Built around daily commerce",
      ],
      storefront: "Storefront",
      searchCatalog: "Search the catalog",
      productGroups: ["New arrivals", "Popular products", "Recommended"],
      adminWorkspace: "Admin workspace",
      orders: "Orders",
      inventory: "Inventory",
      customers: "Customers",
      salesOverview: "Sales overview",
    },
    capabilities: {
      eyebrow: "Built for Real Store Operations",
      title: "The Tools Behind a Better Store",
      description:
        "WECP brings the customer experience and the operational details into one connected product.",
      areas: [
        {
          title: "A storefront customers understand",
          description:
            "Help shoppers find the right product, compare options, and move confidently toward checkout.",
          features: [
            "Responsive catalog with search, sorting, and detailed filters",
            "Product variants, favorites, reviews, and related products",
            "Guest and customer carts with a guided checkout flow",
          ],
        },
        {
          title: "Daily operations in one place",
          description:
            "Give your team a focused workspace for the work that keeps an online store moving.",
          features: [
            "Products, categories, brands, attributes, and variants",
            "Inventory, orders, customers, and contact messages",
            "Sales and customer reporting across flexible date ranges",
          ],
        },
        {
          title: "A store that feels like your brand",
          description:
            "Control the presentation and store information without rebuilding the storefront.",
          features: [
            "Theme colors, logo, homepage sections, and banners",
            "Store languages and translated catalog content",
            "Currencies, contact details, working hours, and social links",
          ],
        },
      ],
    },
    workflow: {
      eyebrow: "A Practical Commerce Flow",
      title: "From Catalog to Customer",
      description:
        "Set up the store, sell with less friction, and keep improving from one clear workflow.",
      steps: [
        {
          title: "Shape your catalog",
          description:
            "Organize products with categories, brands, variants, attributes, and inventory.",
        },
        {
          title: "Build your storefront",
          description:
            "Set the theme, homepage content, featured products, banners, and business details.",
        },
        {
          title: "Sell and fulfill",
          description:
            "Support discovery, checkout, customer accounts, order handling, and delivery details.",
        },
        {
          title: "Learn and improve",
          description:
            "Use practical sales and customer insights to guide the next decision.",
        },
      ],
    },
    cta: {
      title: "Ready to Launch Your Store?",
      description:
        "Let's build a powerful E-commerce experience that drives sales, delights customers, and grows your brand.",
      imageAlt: "Warenex e-commerce platform preview",
    },
  },
};

export default en;
